import { Form } from "@/components/organisms/Form";
import { Term } from "@/components/molecules/Term";
import { Buttons } from "@/components/atoms/Buttons";
import { useState } from "react";
import { PhotoTerms } from "@/data/terms";
import { useNavigate } from "react-router";
import { MainTemplate } from "@/components/templates/MainTemplate";
import { InputCheckbox } from "@/components/atoms/Inputs/InputCheckbox";
import { useRecoilState } from "recoil";
import { JoinProcessBar } from "@/components/atoms/JoinProcessBar";
import { photoAgreeState } from "@/common/states/agree";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow.svg";

export const PhotoAgreePage = () => {
  const navigate = useNavigate();
  const [agree, setAgree] = useRecoilState(photoAgreeState);
  const [agreeTime, setAgreeTime] = useState<Date | null>(null);

  return (
    <MainTemplate
      nav={false}
      subPage={true}
      menuBtn={false}
      buttonLeft={
        <Buttons
          type="button"
          size="headerTextIcon"
          layout="text"
          color="bright100"
          icon={<IconArrow />}
          label="건강"
          onClick={() => navigate("/spine")}
        />
      }
      pageTitle="척추 사진 촬영"
    >
      <Form
        processBar={<JoinProcessBar stepNow={1} stepTotal={5} />}
        title="사진 활용 동의"
        text={
          <>
            학생 회원의 본 서비스 이용을 위해서는 아래의
            <br />
            사진 활용에 대한 학생 및 보호자의 동의가 필요합니다.
          </>
        }
        submitBtn={
          <Buttons
            type="submit"
            size="lg"
            color="primary100"
            layout="solid"
            label="다음"
            disabled={!agreeTime}
            onClick={() => {
              setAgree(agreeTime);
              navigate("/spine/photo-guide01", { replace: true });
            }}
          />
        }
        backBtn={
          <Buttons
            type="button"
            size="lg"
            color="primary100"
            layout="text"
            label="뒤로"
            onClick={() => window.history.back()}
          />
        }
      >
        <Term
          processBar={true}
          text={<PhotoTerms />}
          checkbox={
            <InputCheckbox
              size="lg"
              name="photo-agree"
              data={[
                {
                  id: 1,
                  value: "",
                  displayExpr:
                    "위 사진 활용의 목적 및 필요성에 대해 이해했으며, 사진 활용에 동의합니다.",
                },
              ]}
              onChange={(e) => {
                if (e.target.checked) {
                  setAgreeTime(new Date());
                } else {
                  setAgreeTime(null);
                }
              }}
            />
          }
        />
      </Form>
    </MainTemplate>
  );
};
